import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ProductContext, ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import updateProductInfo from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/UpdateProductInfo";
import { getProductInfoFromList } from "@insite/client-framework/Store/Components/ProductInfoList/ProductInfoListSelectors";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
// import ProductAddToCartButton from "@insite/content-library/Components/ProductAddToCartButton"; // Poolcorp Custom Code
import ProductAddToListLink, {
    ProductAddToListLinkStyles,
} from "@insite/content-library/Components/ProductAddToListLink";
import { ProductAvailabilityStyles } from "@insite/content-library/Components/ProductAvailability";
import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import ProductContextAvailability from "@insite/content-library/Components/ProductContextAvailability";
import ProductDescription, { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import ProductImage, { ProductImageStyles } from "@insite/content-library/Components/ProductImage";
// import ProductPartNumbers, { ProductPartNumbersStyles } from "@insite/content-library/Components/ProductPartNumbers"; // Poolcorp Custom Code
// import ProductPrice, { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice"; // Poolcorp Custom Code
import ProductQuantityBreakPricing, {
    ProductQuantityBreakPricingStyles,
} from "@insite/content-library/Components/ProductQuantityBreakPricing";
import ProductQuantityOrdered from "@insite/content-library/Components/ProductQuantityOrdered";
import ProductUnitOfMeasureSelect from "@insite/content-library/Components/ProductUnitOfMeasureSelect";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
// import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer"; // Poolcorp Custom Code
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import { TextFieldPresentationProps } from "@insite/mobius/TextField";
// import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries"; // Poolcorp Custom Code
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

/* Poolcorp Custom Code */
import translate from "@insite/client-framework/Translate";
import GridContainer, { GridContainerProps, GridOffset } from "@insite/mobius/GridContainer";
import Hidden from "@insite/mobius/Hidden";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { SelectPresentationProps } from "@insite/mobius/Select";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import ProductAddToCartButton from "@store/Overrides/Components/ProductAddToCartButton";
import ProductPartNumbers, { ProductPartNumbersStyles } from "@store/Overrides/Components/ProductPartNumbers";
import ProductPrice, { ProductPriceStyles } from "@store/Overrides/Components/ProductPrice";
import { quantityInputStyles } from "@store/theme/common/mixins";
import { productLineProps } from "@store/theme/common/props/productLine";
import breakpointValuesMediaQueries from "@store/utilities/breakpointValuesMediaQueries";
/* Poolcorp Custom Code */

interface OwnProps {
    product: ProductModel;
    widgetId: string;
    showBrand: boolean;
    showPartNumbers: boolean;
    showPrice: boolean;
    showAvailability: boolean;
    showAddToCart: boolean;
    showAddToList: boolean;
    extendedStyles?: PurchasedProductCardStyles;
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => ({
    productSettings: getSettingsCollection(state).productSettings,
    productInfo: getProductInfoFromList(state, ownProps.widgetId, ownProps.product.id),
});

const mapDispatchToProps = {
    updateProductInfo,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface PurchasedProductCardStyles {
    container?: GridContainerProps;
    leftColumnGridItem?: GridItemProps;
    productImage?: ProductImageStyles;
    rightColumnGridItem?: GridItemProps;
    rightColumnGridContainer?: GridContainerProps;
    infoGridItem?: GridItemProps;
    infoContainer?: GridContainerProps;
    brandStyles?: ProductBrandStyles;
    descriptionStyles?: ProductDescriptionStyles;
    brandGridItem?: GridItemProps;
    descriptionGridItem?: GridItemProps;
    partNumbersGridItem?: GridItemProps;
    partNumbersStyles?: ProductPartNumbersStyles;
    availabilityGridItem?: GridItemProps;
    availabilityStyles?: ProductAvailabilityStyles;
    priceGridItem?: GridItemProps;
    priceStyles?: ProductPriceStyles;
    quantityBreakPricing?: ProductQuantityBreakPricingStyles;
    actionsGridItem?: GridItemProps;
    actionsContainer?: GridContainerProps;
    quantityGridItem?: GridItemProps;
    quantityOrdered?: TextFieldPresentationProps;
    addToGridItem?: GridItemProps;
    addToCartButton?: ButtonPresentationProps;
    addToListWrapper?: InjectableCss;
    addToListLink?: ProductAddToListLinkStyles;
	// Poolcorp Custom Code
	brandAndDescriptionGridItem?: GridItemProps;
	quantityAndPriceGridItem?: GridItemProps;
	quantityAndPriceGridContainer?: GridContainerProps;
	priceAndAvailabilityGridItem?: GridItemProps;
	priceWrapper?: InjectableCss;
	quantityWrapper?: InjectableCss;
	actionLink?: LinkPresentationProps;
	unitOfMeasureSelectGridItem?: GridItemProps;
	smallHeading?: TypographyPresentationProps;
	productUnitOfMeasureSelectStyles?: SelectPresentationProps;
	addToWrapper?: InjectableCss;
}

export const purchasedProductCardStyles: PurchasedProductCardStyles = {
    container: {
        ...productLineProps.container,
        css: css`
            ${productLineProps.container?.css}
            border-bottom: 1px solid ${getColor("common.border")};
        `,
    },
    leftColumnGridItem: {
		...productLineProps.imageGridItem,
		width: [4, 3, 2, 2, 2],
	},
	productImage: productLineProps.productImage,
	actionLink: {
        ...productLineProps.actionLink,
        css: css`
            ${productLineProps.actionLink?.css}
            &:disabled {
                color: ${getColor("common.disabled")};
            }
        `,
    },
	addToListLink: {
		link: productLineProps.actionLink,
	},
    rightColumnGridItem: {
		...productLineProps.infoGridItem,
		width: [8, 9, 10, 10, 10],
		css: css`
			${productLineProps.infoGridItem?.css}
			align-items: flex-start;
			${({ theme }) =>
				breakpointValuesMediaQueries(
					theme,
					[{ values: [null, null, null, "center"], properties: ["align-items"] }],
					mediaOptions.min,
				)}
		`,
	},
    rightColumnGridContainer: productLineProps.infoContainer,
    infoGridItem: {
		...productLineProps.descriptionGridItem,
		width: [12, 12, 5, 5, 5],
	},
    infoContainer: productLineProps.descriptionContainer,
    descriptionStyles: productLineProps.productDescription,
    brandAndDescriptionGridItem: productLineProps.headingGridItem,
    partNumbersGridItem: productLineProps.partNumbersGridItem,
    partNumbersStyles: productLineProps.productPartNumbers,
	unitOfMeasureSelectGridItem: {
		width: [12, 6, 4, 3, 3],
		css: css`
			flex-direction: column;
		`,
	},
	smallHeading: {
        variant: "legend",
        css: css`
            margin: 0.5em 0;
        `,
    },
	productUnitOfMeasureSelectStyles: {
        sizeVariant: "small",
		css: css`
            margin-bottom: 0.5em;
        `,
    },
	quantityAndPriceGridItem: {
		...productLineProps.priceAndQuantityGridItem,
		width: [12, 12, 7, 7, 7],
	},
	quantityAndPriceGridContainer: {
		...productLineProps.priceAndQuantityContainer,
		css: css`
			${productLineProps.priceAndQuantityContainer?.css}
			${GridOffset} { 
				justify-content: flex-start;
				${({ theme }) =>
					breakpointValuesMediaQueries(
						theme,
						[{ values: [null, null, "flex-end"], properties: ["justify-content"] }],
						mediaOptions.min,
					)}
			}
		`,
	},
	priceAndAvailabilityGridItem: {
		...productLineProps.priceGridItem,
		width: [12, 6, 4, 3, 3],
		css: css`
			${productLineProps.priceGridItem?.css}
			justify-content: center;
			align-items: flex-start;
			${({ theme }) =>
				breakpointValuesMediaQueries(
					theme,
					[{ values: [null, null, "center"], properties: ["align-items"] }],
					mediaOptions.min,
				)}
		`,
	},
	priceWrapper: {
		css: css`
			display: flex;
			flex-direction: column;
			align-items: flex-start;
		`,
	},
    priceStyles: productLineProps.price,
    quantityBreakPricing: {
        viewLink: {
            typographyProps: { size: 12 },
            css: css`
                text-align: end;
				${({ theme }) =>
					breakpointValuesMediaQueries(
						theme,
						[{ values: [null, null, "flex-end"], properties: ["align-self"] }],
						mediaOptions.min,
					)}
            `,
        },
    },
	quantityGridItem: {
        width: [12, 12, 4, 3, 3],
        css: css`
            flex-direction: column;
			align-items: flex-start;
			${({ theme }) =>
				breakpointValuesMediaQueries(
					theme,
					[{ values: [null, null, "center"], properties: ["align-items"] }],
					mediaOptions.min,
				)}
        `,
    },
	quantityOrdered: {
        sizeVariant: "small",
        labelProps: {
            variant: "legend",
        },
        cssOverrides: {
            inputSelect: css`
                ${quantityInputStyles()}
            `,
        },
    },
	addToGridItem: {
		width: [0, 0, 0, 3, 3],
		css: css`
			flex-direction: column;
			justify-content: center;
    		align-items: center;
		`,
	},
	addToWrapper: {
		css: css`
			display: flex;
			flex-direction: column;
			align-items: center;
		`,
	},
};

const PurchasedProductCard: React.FC<Props> = ({
    product,
    productInfo,
    showBrand,
    showPartNumbers,
    showPrice,
    showAvailability,
    showAddToCart,
    showAddToList,
    productSettings,
    extendedStyles,
    updateProductInfo,
    widgetId,
}) => {
    const [styles] = React.useState(() => mergeToNew(purchasedProductCardStyles, extendedStyles));

    if (!productInfo || !product) {
        return null;
    }

    const productContext: ProductContextModel = {
        product,
        productInfo,
        onUnitOfMeasureChanged: unitOfMeasure => {
            updateProductInfo({ id: widgetId, productId: product.id, unitOfMeasure });
        },
        onQtyOrderedChanged: qtyOrdered => {
            updateProductInfo({ id: widgetId, productId: product.id, qtyOrdered });
        },
    };

    return (
        <ProductContext.Provider value={productContext} data-test-selector="widget_PurchasedProducts">
            <GridContainer {...styles.container} data-test-selector={`purchasedProductCard_${product.id}`}>
                <GridItem {...styles.leftColumnGridItem}>
                    <ProductImage extendedStyles={styles.productImage} product={productContext} /* Poolcorp Removed Code - showSmallImage */ />
					{/* Poolcorp Custom Code */}
					<Hidden {...styles.addToWrapper} above="md">
						{showAddToCart && (
							<ProductAddToCartButton
								data-test-selector={`actionsAddToCart${product.id}`}
								extendedLinkStyles={styles.actionLink}
								asLink
							/>
						)}
						{showAddToList && (
							<ProductAddToListLink
								data-test-selector={`actionsAddToList${product.id}`}
								extendedStyles={styles.addToListLink}
							/>
						)}
					</Hidden>
					{/* Poolcorp Custom Code */}
                </GridItem>
				{/* Poolcorp Custom Code */}
                <GridItem {...styles.rightColumnGridItem}>
                    <GridContainer {...styles.rightColumnGridContainer}>
                        <GridItem {...styles.infoGridItem}>
                            <GridContainer {...styles.infoContainer}>
								<GridItem {...styles.brandAndDescriptionGridItem}>
									{product.brand && showBrand && (
										<ProductBrand brand={product.brand} extendedStyles={styles.brandStyles} />
									)}
									<ProductDescription
										product={productContext}
										extendedStyles={styles.descriptionStyles}
									/>
								</GridItem>
                                {showPartNumbers && (
                                    <GridItem {...styles.partNumbersGridItem}>
                                        <ProductPartNumbers
                                            productNumber={product.productNumber}
                                            customerProductNumber={product.customerProductNumber}
                                            manufacturerItem={product.manufacturerItem}
                                            extendedStyles={styles.partNumbersStyles}
                                        />
                                    </GridItem>
                                )}
                            </GridContainer>
                        </GridItem>
						<GridItem {...styles.quantityAndPriceGridItem}>
							<GridContainer {...styles.quantityAndPriceGridContainer}>
								{product.unitOfMeasures && product.unitOfMeasures.filter(uom => uom.unitOfMeasure).length >= 2 && (
									<GridItem {...styles.unitOfMeasureSelectGridItem}>
										<>
											<Typography {...styles.smallHeading}>
												{translate("U/M")}
											</Typography>
											<ProductUnitOfMeasureSelect 
												id={`${product.id}-uom`}
												labelOverride="" 
												extendedStyles={styles.productUnitOfMeasureSelectStyles} 
											/>
										</>
									</GridItem>
								)}
								<GridItem {...styles.priceAndAvailabilityGridItem}>
									<StyledWrapper {...styles.priceWrapper}>
										{showPrice && (
											<ProductPrice
												product={productContext}
												showLabel={false}
												showSavings={true}
												showSavingsAmount={productSettings.showSavingsAmount}
												showSavingsPercent={productSettings.showSavingsPercent}
												extendedStyles={styles.priceStyles}
												showSingle
											/>
										)}
										<ProductQuantityBreakPricing extendedStyles={styles.quantityBreakPricing} />
										{productSettings.showInventoryAvailability && showAvailability && (
											<ProductContextAvailability extendedStyles={styles.availabilityStyles} />
										)}
									</StyledWrapper>
								</GridItem>
								<GridItem {...styles.quantityGridItem}>
									{showAddToCart && (
										<StyledWrapper {...styles.quantityWrapper}>
											<Typography {...styles.smallHeading}>
												{translate("QTY")}
											</Typography>
											<ProductQuantityOrdered 
												labelOverride=""
												extendedStyles={styles.quantityOrdered}
											/>
										</StyledWrapper>
									)}
								</GridItem>
								<GridItem {...styles.addToGridItem}>
									<Hidden {...styles.addToWrapper} below="lg">
										{showAddToCart && (
											<ProductAddToCartButton
												data-test-selector={`actionsAddToCart${product.id}`}
												extendedLinkStyles={styles.actionLink}
												asLink
											/>
										)}
										{showAddToList && (
											<ProductAddToListLink
												data-test-selector={`actionsAddToList${product.id}`}
												extendedStyles={styles.addToListLink}
											/>
										)}
									</Hidden>
								</GridItem>
							</GridContainer>
						</GridItem>
                    </GridContainer>
                </GridItem>
				{/* Poolcorp Custom Code */}
            </GridContainer>
        </ProductContext.Provider>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(PurchasedProductCard);
